// // src/app/modules/NetworkIntelligence/pages/NetworkIntelligence.jsx

// import React, { useEffect, useState, useRef } from "react";
// import { shallowEqual, useSelector, useDispatch } from "react-redux";
// import { MapContainer, TileLayer, CircleMarker, Popup, Circle, useMap } from 'react-leaflet';
// import L from 'leaflet';
// import 'leaflet/dist/leaflet.css';
// import * as actions from "../../Dashbord/_redux/dashboard/Actions";
// import './network-intelligence.scss';

// import {
//   Brain, MapPin, Clock, TrendingUp, TrendingDown,
//   AlertTriangle, Shield, Target, Activity, Zap,
//   CheckCircle, AlertOctagon, RefreshCw, Loader,
//   Calendar, Database,
// } from 'lucide-react';

// // Fix Leaflet icons
// delete L.Icon.Default.prototype._getIconUrl;
// L.Icon.Default.mergeOptions({
//   iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
//   iconUrl:       'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
//   shadowUrl:     'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
// });

// function MapController({ center }) {
//   const map = useMap();
//   useEffect(() => { if (center) map.setView(center, map.getZoom()); }, [center, map]);
//   return null;
// }

// function getSeverityColor(level) {
//   const map = {
//     critical: '#DC2626', high: '#D97706', high_risk: '#D97706',
//     medium: '#2563EB', moderate: '#2563EB', low: '#16a34a', safe: '#16a34a',
//   };
//   return map[level] || '#9597A6';
// }

// function getSeverityIcon(level) {
//   if (level === 'critical' || level === 'high' || level === 'high_risk')
//     return <AlertOctagon size={16} />;
//   if (level === 'medium' || level === 'moderate')
//     return <AlertTriangle size={16} />;
//   return <CheckCircle size={16} />;
// }

// export function NetworkIntelligence() {
//   const dispatch     = useDispatch();
//   const isMountedRef = useRef(true);
//   const [activeTab,  setActiveTab]  = useState('overview');
//   const [mapCenter,  setMapCenter]  = useState([6.5244, 3.3792]);

//   const { org, loading, safetyScore, timeAnalysis, nearbyIncidents, incidentPatterns, riskPrediction } =
//     useSelector((state) => ({
//       org:              state.auth.organization,
//       loading:          state.dashboard.listLoading,
//       safetyScore:      state.dashboard.safetyScore,
//       timeAnalysis:     state.dashboard.timeAnalysis,
//       nearbyIncidents:  state.dashboard.nearbyIncidents,
//       incidentPatterns: state.dashboard.incidentPatterns,
//       riskPrediction:   state.dashboard.riskPrediction,
//     }), shallowEqual);

//   useEffect(() => { isMountedRef.current = true; return () => { isMountedRef.current = false; }; }, []);

//   useEffect(() => {
//     if (org?.address?.coordinates) {
//       const [lon, lat] = org.address.coordinates;
//       setMapCenter([lat, lon]);
//       loadData(lat, lon);
//     } else {
//       loadData(6.5244, 3.3792);
//     }
//   }, [org]);

//   function loadData(lat, lon) {
//     if (!lat || !lon || !isMountedRef.current) return;
//     dispatch(actions.fetchAllData('safety_score',     null, { lat, lng: lon, radius: 5 }));
//     dispatch(actions.fetchAllData('time_analysis',    null, { lat, lng: lon, radius: 5 }));
//     dispatch(actions.fetchAllData('nearby_incidents', null, { latitude: lat, longitude: lon, radius_km: 5, limit: 50 }));
//     dispatch(actions.fetchAllData('incident_patterns', null, { lat, lng: lon, radius: 5 }));
//     dispatch(actions.fetchAllData('risk_prediction',  null, { lat, lng: lon, radius: 5, days: 7 }));
//   }

//   function refreshData() {
//     if (org?.address?.coordinates) {
//       const [lon, lat] = org.address.coordinates;
//       loadData(lat, lon);
//     } else {
//       loadData(6.5244, 3.3792);
//     }
//   }

//   const hasData = safetyScore || timeAnalysis || nearbyIncidents || incidentPatterns || riskPrediction;

//   const tabs = [
//     { id: 'overview',      label: 'Overview',       icon: <TrendingUp size={13} /> },
//     { id: 'risk-map',      label: 'Risk Map',        icon: <MapPin size={13} /> },
//     { id: 'time-analysis', label: 'Time Analysis',   icon: <Clock size={13} /> },
//     { id: 'predictions',   label: 'Predictions',     icon: <Brain size={13} /> },
//   ];

//   const quickStats = [
//     { icon: <AlertTriangle size={18} />, bg: '#FEF2F2', color: '#DC2626', label: 'Nearby Incidents',  value: nearbyIncidents?.length || 0,  sub: 'Within 5km' },
//     { icon: <Shield size={18} />,        bg: '#F0EEFF', color: '#5341C4', label: 'Primary Threat',    value: incidentPatterns?.incident_types?.[0]?.type?.replace('_', ' ') || 'None', sub: `${incidentPatterns?.incident_types?.[0]?.count || 0} cases` },
//     { icon: <Brain size={18} />,         bg: '#FFFBEB', color: '#D97706', label: 'Predicted (7d)',    value: riskPrediction?.predicted_incidents || 0, sub: `${riskPrediction?.confidence || 'low'} confidence` },
//     { icon: <Clock size={18} />,         bg: '#EFF6FF', color: '#2563EB', label: 'Highest Risk Hour', value: timeAnalysis?.recommendations?.most_dangerous_hour?.split(' - ')[0] || '—', sub: timeAnalysis?.recommendations?.most_dangerous_day || 'Analysing…' },
//   ];

//   return (
//     <div className="ni-page">

//       {/* ── Header ── */}
//       <div className="ni-header">
//         <div className="ni-header__left">
//           <h1>
//             Network Intelligence
//             <span className="ni-ai-badge">AI</span>
//           </h1>
//           <p>
//             {org?.name} · Real-time safety insights
//             {org?.address?.formatted_address && (
//               <> · <MapPin size={11} style={{ display: 'inline', verticalAlign: 'middle' }} /> {org.address.formatted_address}</>
//             )}
//           </p>
//         </div>
//         <button className="ni-btn ni-btn--secondary" onClick={refreshData} disabled={loading}>
//           <RefreshCw size={13} className={loading ? 'ni-spin' : ''} />
//           Refresh
//         </button>
//       </div>

//       {/* ── Tabs ── */}
//       <div className="ni-tabs">
//         {tabs.map(t => (
//           <button key={t.id} className={`ni-tab ${activeTab === t.id ? 'active' : ''}`} onClick={() => setActiveTab(t.id)}>
//             {t.icon}{t.label}
//           </button>
//         ))}
//       </div>

//       {/* ── Loading ── */}
//       {loading && !hasData && (
//         <div className="ni-card">
//           <div className="ni-loading">
//             <Loader size={28} className="ni-spin" />
//             <p>Loading intelligence data…</p>
//           </div>
//         </div>
//       )}

//       {/* ── No data ── */}
//       {!loading && !hasData && (
//         <div className="ni-card">
//           <div className="ni-empty">
//             <Database size={40} />
//             <p>No intelligence data available</p>
//             <small>Unable to load data for your location. Try refreshing.</small>
//           </div>
//         </div>
//       )}

//       {hasData && (
//         <>
//           {/* ══ OVERVIEW ══════════════════════════════════════════════════════ */}
//           {activeTab === 'overview' && (
//             <>
//               {/* Safety score + quick stats strip */}
//               <div className="ni-strip">

//                 {/* Left: score circle */}
//                 <div className="ni-score-panel">
//                   <div className="ni-score-circle"
//                     style={{ background: `conic-gradient(${getSeverityColor(safetyScore?.level)} ${safetyScore?.score || 0}%, #EAEAF0 ${safetyScore?.score || 0}%)` }}>
//                     <div className="ni-score-inner">
//                       <div className="ni-score-value">{safetyScore?.score || 0}</div>
//                       <div className="ni-score-sub">Safety Score</div>
//                     </div>
//                   </div>

//                   <div className="ni-score-level" style={{ color: getSeverityColor(safetyScore?.level), background: getSeverityColor(safetyScore?.level) + '18' }}>
//                     {getSeverityIcon(safetyScore?.level)}
//                     {safetyScore?.level?.replace('_', ' ').toUpperCase() || 'CALCULATING'}
//                   </div>

//                   <div className="ni-score-metrics">
//                     <div className="ni-score-metric">
//                       <span>{safetyScore?.breakdown?.recent_incidents_7d || 0}</span>
//                       <small>Last 7 days</small>
//                     </div>
//                     <div className="ni-score-metric">
//                       <span style={{ textTransform: 'capitalize' }}>{safetyScore?.breakdown?.trend || 'stable'}</span>
//                       <small>Trend</small>
//                     </div>
//                     <div className="ni-score-metric">
//                       <span>{safetyScore?.breakdown?.avg_severity || 0}/10</span>
//                       <small>Avg Severity</small>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Right: quick stat chips 2x2 */}
//                 <div className="ni-quick-stats">
//                   {quickStats.map((s, i) => (
//                     <div key={i} className="ni-quick-stat">
//                       <div className="ni-quick-stat__icon" style={{ background: s.bg, color: s.color }}>{s.icon}</div>
//                       <div>
//                         <div className="ni-quick-stat__label">{s.label}</div>
//                         <div className="ni-quick-stat__value" style={{ textTransform: 'capitalize' }}>{s.value}</div>
//                         <div className="ni-quick-stat__sub">{s.sub}</div>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </div>

//               {/* Recommendations */}
//               <div className="ni-card">
//                 <div className="ni-card__header">
//                   <div className="ni-card__title"><Target size={14} />Actionable Recommendations</div>
//                 </div>
//                 <div className="ni-card__body">
//                   <div className="ni-recs">
//                     <div className="ni-rec ni-rec--warning">
//                       <AlertTriangle size={16} />
//                       <div>
//                         <strong>Security Timing</strong>
//                         <p>{timeAnalysis?.recommendations?.advice || 'Maintain vigilance during peak hours'}</p>
//                       </div>
//                     </div>
//                     {(safetyScore?.score || 100) < 50 && (
//                       <div className="ni-rec ni-rec--danger">
//                         <AlertOctagon size={16} />
//                         <div>
//                           <strong>Enhanced Security Needed</strong>
//                           <p>Consider increasing security presence during high-risk periods</p>
//                         </div>
//                       </div>
//                     )}
//                     {(safetyScore?.breakdown?.critical_incidents || 0) > 0 && (
//                       <div className="ni-rec ni-rec--danger">
//                         <Shield size={16} />
//                         <div>
//                           <strong>Critical Incidents Detected</strong>
//                           <p>{safetyScore.breakdown.critical_incidents} critical incidents recorded in your area</p>
//                         </div>
//                       </div>
//                     )}
//                     <div className="ni-rec ni-rec--info">
//                       <Activity size={16} />
//                       <div>
//                         <strong>Monitor Trends</strong>
//                         <p>Area safety is <strong style={{ textTransform: 'capitalize' }}>{safetyScore?.breakdown?.trend || 'stable'}</strong> — check back regularly</p>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Recent incidents feed */}
//               <div className="ni-card">
//                 <div className="ni-card__header">
//                   <div className="ni-card__title"><AlertTriangle size={14} />Recent Incidents Near You</div>
//                   <span className="ni-card__meta">{nearbyIncidents?.length || 0} within 5km</span>
//                 </div>
//                 <div className="ni-feed">
//                   {nearbyIncidents && nearbyIncidents.length > 0 ? (
//                     nearbyIncidents.slice(0, 10).map((inc, i) => (
//                       <div key={i} className="ni-feed-item">
//                         <div className="ni-feed-item__icon" style={{ background: getSeverityColor(inc.severity) + '18', color: getSeverityColor(inc.severity) }}>
//                           {getSeverityIcon(inc.severity)}
//                         </div>
//                         <div className="ni-feed-item__body">
//                           <div className="ni-feed-item__row">
//                             <span className="ni-feed-item__type" style={{ textTransform: 'capitalize' }}>{inc.type?.replace('_', ' ')}</span>
//                             <span className="ni-feed-item__time">{inc.time}</span>
//                           </div>
//                           <div className="ni-feed-item__loc"><MapPin size={11} />{inc.location}</div>
//                           {inc.details && <p className="ni-feed-item__desc">{inc.details}</p>}
//                         </div>
//                         <div className="ni-feed-item__badge" style={{ background: getSeverityColor(inc.severity) + '18', color: getSeverityColor(inc.severity) }}>
//                           {inc.severity}
//                         </div>
//                       </div>
//                     ))
//                   ) : (
//                     <div className="ni-empty" style={{ padding: '40px 20px' }}>
//                       <CheckCircle size={36} style={{ color: '#16a34a' }} />
//                       <p>No recent incidents in your area</p>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </>
//           )}

//           {/* ══ RISK MAP ══════════════════════════════════════════════════════ */}
//           {activeTab === 'risk-map' && (
//             <div className="ni-card">
//               <div className="ni-card__header">
//                 <div className="ni-card__title"><MapPin size={14} />Incident Risk Map</div>
//                 <span className="ni-card__meta">5km radius · {nearbyIncidents?.length || 0} incidents plotted</span>
//               </div>
//               <div className="ni-map-wrap">
//                 <MapContainer
//                   key={`${mapCenter[0]}-${mapCenter[1]}`}
//                   center={mapCenter} zoom={13} scrollWheelZoom
//                   style={{ height: '100%', width: '100%' }}
//                 >
//                   <TileLayer
//                     url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//                     attribution="&copy; OpenStreetMap contributors"
//                   />
//                   <MapController center={mapCenter} />
//                   <CircleMarker center={mapCenter} radius={10}
//                     pathOptions={{ color: '#5341C4', fillColor: '#5341C4', fillOpacity: 0.85 }}>
//                     <Popup><strong>{org?.name}</strong></Popup>
//                   </CircleMarker>
//                   <Circle center={mapCenter} radius={5000}
//                     pathOptions={{ color: getSeverityColor(safetyScore?.level), fillOpacity: 0.07, weight: 1.5 }} />
//                   {nearbyIncidents?.map((inc, i) => {
//                     if (!inc.coordinates || inc.coordinates.length !== 2) return null;
//                     return (
//                       <CircleMarker key={i} center={[inc.coordinates[1], inc.coordinates[0]]} radius={6}
//                         pathOptions={{ color: getSeverityColor(inc.severity), fillColor: getSeverityColor(inc.severity), fillOpacity: 0.75 }}>
//                         <Popup><strong style={{ textTransform: 'capitalize' }}>{inc.type?.replace('_', ' ')}</strong><br /><small>{inc.location}</small></Popup>
//                       </CircleMarker>
//                     );
//                   })}
//                 </MapContainer>
//               </div>
//             </div>
//           )}

//           {/* ══ TIME ANALYSIS ═════════════════════════════════════════════════ */}
//           {activeTab === 'time-analysis' && (
//             <>
//               {timeAnalysis?.hourly && timeAnalysis?.daily ? (
//                 <>
//                   <div className="ni-two-col">
//                     {/* Hourly */}
//                     <div className="ni-card">
//                       <div className="ni-card__header">
//                         <div className="ni-card__title"><Clock size={14} />Hourly Risk Pattern</div>
//                       </div>
//                       <div className="ni-card__body">
//                         <div className="ni-hourly">
//                           {timeAnalysis.hourly.map((h, i) => (
//                             <div key={i} className="ni-hour-row">
//                               <span className="ni-hour-label">{h.hour}</span>
//                               <div className="ni-hour-track">
//                                 <div className={`ni-hour-fill ni-hour-fill--${h.risk}`}
//                                   style={{ width: `${Math.min(100, (h.incidents / 10) * 100)}%` }} />
//                               </div>
//                               <span className="ni-hour-count">{h.incidents}</span>
//                             </div>
//                           ))}
//                         </div>
//                       </div>
//                     </div>

//                     {/* Daily */}
//                     <div className="ni-card">
//                       <div className="ni-card__header">
//                         <div className="ni-card__title"><Calendar size={14} />Daily Risk Pattern</div>
//                       </div>
//                       <div className="ni-card__body">
//                         <div className="ni-daily">
//                           {timeAnalysis.daily.map((d, i) => (
//                             <div key={i} className="ni-day-col">
//                               <span className="ni-day-name">{d.day.substring(0, 3)}</span>
//                               <div className="ni-day-track">
//                                 <div className={`ni-day-fill ni-day-fill--${d.risk}`}
//                                   style={{ height: `${Math.min(100, (d.incidents / 20) * 100)}%` }} />
//                               </div>
//                               <span className="ni-day-count">{d.incidents}</span>
//                             </div>
//                           ))}
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   {/* Timing rec */}
//                   <div className="ni-card">
//                     <div className="ni-card__header">
//                       <div className="ni-card__title"><Zap size={14} />Timing Recommendations</div>
//                     </div>
//                     <div className="ni-card__body">
//                       <div className="ni-recs">
//                         <div className="ni-rec ni-rec--success">
//                           <CheckCircle size={16} />
//                           <div>
//                             <strong>Safest Time</strong>
//                             <p>{timeAnalysis.recommendations?.safest_hour || '—'} on {timeAnalysis.recommendations?.safest_day || '—'}</p>
//                           </div>
//                         </div>
//                         <div className="ni-rec ni-rec--danger">
//                           <AlertTriangle size={16} />
//                           <div>
//                             <strong>Highest Risk</strong>
//                             <p>{timeAnalysis.recommendations?.most_dangerous_hour || '—'} on {timeAnalysis.recommendations?.most_dangerous_day || '—'}</p>
//                           </div>
//                         </div>
//                         <div className="ni-rec ni-rec--info">
//                           <Activity size={16} />
//                           <div>
//                             <strong>Security Advice</strong>
//                             <p>{timeAnalysis.recommendations?.advice || 'Maintain standard security protocols'}</p>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </>
//               ) : (
//                 <div className="ni-card">
//                   <div className="ni-empty">
//                     <Clock size={40} />
//                     <p>No time analysis data available</p>
//                     <small>Insufficient data to generate time-based risk analysis</small>
//                   </div>
//                 </div>
//               )}
//             </>
//           )}

//           {/* ══ PREDICTIONS ═══════════════════════════════════════════════════ */}
//           {activeTab === 'predictions' && (
//             <>
//               {riskPrediction ? (
//                 <div className="ni-two-col">
//                   {/* Forecast */}
//                   <div className="ni-card">
//                     <div className="ni-card__header">
//                       <div className="ni-card__title"><Brain size={14} />7-Day Risk Forecast</div>
//                       <span className="ni-card__meta" style={{ textTransform: 'capitalize' }}>{riskPrediction.confidence} confidence</span>
//                     </div>
//                     <div className="ni-card__body">
//                       <div className="ni-forecast">
//                         <div className="ni-forecast__visual">
//                           {riskPrediction.trend === 'increasing' ? <TrendingUp size={36} /> :
//                            riskPrediction.trend === 'decreasing' ? <TrendingDown size={36} /> :
//                            <Activity size={36} />}
//                           <div className="ni-forecast__num">{riskPrediction.predicted_incidents || 0}</div>
//                           <div className="ni-forecast__label">Predicted Incidents</div>
//                         </div>
//                         <div className="ni-forecast__details">
//                           {[
//                             { label: 'Trend',      value: riskPrediction.trend || 'stable' },
//                             { label: 'Risk Level', value: riskPrediction.prediction || 'low' },
//                             { label: 'Based On',   value: `${riskPrediction.based_on?.historical_incidents || 0} incidents` },
//                           ].map((d, i) => (
//                             <div key={i} className="ni-forecast__detail">
//                               <span className="ni-forecast__detail-label">{d.label}</span>
//                               <span className="ni-forecast__detail-value" style={{ textTransform: 'capitalize' }}>{d.value}</span>
//                             </div>
//                           ))}
//                         </div>
//                       </div>
//                       {riskPrediction.message && (
//                         <div className="ni-forecast__msg">{riskPrediction.message}</div>
//                       )}
//                     </div>
//                   </div>

//                   {/* Patterns */}
//                   <div className="ni-card">
//                     <div className="ni-card__header">
//                       <div className="ni-card__title"><Activity size={14} />Incident Patterns</div>
//                     </div>
//                     <div className="ni-patterns">
//                       {incidentPatterns?.incident_types?.length > 0 ? (
//                         incidentPatterns.incident_types.slice(0, 5).map((t, i) => (
//                           <div key={i} className="ni-pattern">
//                             <div className="ni-pattern__info">
//                               <span className="ni-pattern__name" style={{ textTransform: 'capitalize' }}>{t.type?.replace('_', ' ')}</span>
//                               <span className="ni-pattern__count">{t.count} cases</span>
//                             </div>
//                             <div className="ni-pattern__track">
//                               <div className="ni-pattern__fill" style={{ width: `${t.percentage}%` }} />
//                             </div>
//                             <span className="ni-pattern__pct">{t.percentage}%</span>
//                           </div>
//                         ))
//                       ) : (
//                         <div className="ni-empty" style={{ padding: '40px 20px' }}>
//                           <Database size={36} />
//                           <p>No pattern data available</p>
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               ) : (
//                 <div className="ni-card">
//                   <div className="ni-empty">
//                     <Brain size={40} />
//                     <p>No prediction data available</p>
//                     <small>Insufficient historical data to generate risk predictions</small>
//                   </div>
//                 </div>
//               )}
//             </>
//           )}
//         </>
//       )}
//     </div>
//   );
// }


// src/app/modules/NetworkIntelligence/pages/NetworkIntelligence.jsx

import React, { useEffect, useState, useRef, useMemo } from "react";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import { MapContainer, TileLayer, CircleMarker, Popup, Circle, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import * as actions from "../../Dashbord/_redux/dashboard/Actions";
import './network-intelligence.scss';

import {
  Brain, MapPin, Clock, TrendingUp, TrendingDown, Minus,
  AlertTriangle, Shield, Target, Activity, Zap,
  CheckCircle, AlertOctagon, RefreshCw, Loader,
  Calendar, Database, ShieldCheck, Info,
  ChevronDown, ChevronUp,
} from 'lucide-react';

// ─── Leaflet icon fix ─────────────────────────────────────────────────────────
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl:       'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl:     'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

// ─── Config — mirrors mobile exactly ─────────────────────────────────────────

const TREND_CONFIG = {
  worsening: { icon: TrendingUp,   color: '#DC2626', label: 'Increasing' },
  improving: { icon: TrendingDown, color: '#16a34a', label: 'Improving'  },
  stable:    { icon: Minus,        color: '#6B7280', label: 'Stable'     },
};

const CONFIDENCE_CONFIG = {
  high:              { label: 'High confidence',   color: '#16a34a' },
  medium:            { label: 'Medium confidence', color: '#D97706' },
  low:               { label: 'Limited data',      color: '#DC2626' },
  insufficient_data: { label: 'Insufficient data', color: '#9CA3AF' },
};

const THREAT_LABELS = {
  terrorism: 'Terrorism', bombing: 'Bombing', shooting: 'Shooting',
  murder: 'Murder', kidnapping: 'Kidnapping', armed_conflict: 'Armed Conflict',
  assault: 'Assault', carjacking: 'Carjacking', robbery: 'Robbery',
  violent_protest: 'Violent Protest', protest: 'Protest', riot: 'Riot',
  burglary: 'Burglary', theft: 'Theft', fire: 'Fire', accident: 'Road Accident',
  infrastructure: 'Infrastructure', health: 'Health/Medical',
  natural_disaster: 'Natural Disaster', other: 'Other',
};

const THREAT_COLORS = {
  terrorism: '#DC2626', bombing: '#DC2626', shooting: '#DC2626', murder: '#DC2626',
  kidnapping: '#9333EA', armed_conflict: '#B45309', assault: '#EA580C',
  carjacking: '#DC2626', robbery: '#D97706', violent_protest: '#EA580C',
  riot: '#991B1B', protest: '#6B7280', burglary: '#B45309', theft: '#D97706',
  fire: '#EF4444', accident: '#F59E0B', infrastructure: '#2563EB',
  health: '#059669', natural_disaster: '#1E3A8A', other: '#6B7280',
};

const THREAT_BG = {
  terrorism: '#FEF2F2', bombing: '#FEF2F2', shooting: '#FEF2F2', murder: '#FEF2F2',
  kidnapping: '#FAF5FF', armed_conflict: '#FFFBEB', assault: '#FFF7ED',
  carjacking: '#FEF2F2', robbery: '#FFFBEB', violent_protest: '#FFF7ED',
  riot: '#FEF2F2', protest: '#F9FAFB', burglary: '#FFFBEB', theft: '#FFFBEB',
  fire: '#FEF2F2', accident: '#FFFBEB', infrastructure: '#EFF6FF',
  health: '#ECFDF5', natural_disaster: '#EFF6FF', other: '#F9FAFB',
};

// Score label + colour — same logic as mobile getScoreLabel / getScoreGradient
const getScoreDisplay = (score, scoreReason) => {
  const isNoData = scoreReason === 'no_data';
  if (isNoData) return { label: 'Uncharted Area', color: '#6366F1', isNoData: true };
  if (score >= 80) return { label: 'Looks Safe',   color: '#16a34a', isNoData: false };
  if (score >= 60) return { label: 'Mostly Safe',  color: '#D97706', isNoData: false };
  if (score >= 40) return { label: 'Stay Alert',   color: '#F97316', isNoData: false };
  return               { label: 'High Risk',       color: '#DC2626', isNoData: false };
};

function getSeverityColor(level) {
  const map = { critical:'#DC2626', high:'#D97706', high_risk:'#D97706',
                medium:'#2563EB', moderate:'#2563EB', low:'#16a34a', safe:'#16a34a' };
  return map[level] || '#9597A6';
}

// ─── Map controller ───────────────────────────────────────────────────────────
function MapController({ center }) {
  const map = useMap();
  useEffect(() => { if (center) map.setView(center, map.getZoom()); }, [center, map]);
  return null;
}

// ─── buildAnalysisBody — rich narrative copy (mirrors mobile exactly) ─────────
function buildAnalysisBody({ score, incidents, criticalZones, trend, nightModifier,
                              avgSeverity, hasIncidentData, scoreReason, topThreats }) {
  if (!hasIncidentData || scoreReason === 'no_data') {
    return `We don't have any recorded incidents for this area yet — it hasn't been mapped in Sety's database. That doesn't mean it's danger-free, just that we haven't received reports here. Stay alert and trust your instincts.`;
  }

  const threatPhrase = (() => {
    if (!topThreats?.length) return null;
    const t = topThreats[0];
    const map = { terrorism:'terrorism', bombing:'explosive incidents', kidnapping:'kidnapping',
      armed_conflict:'armed conflict', murder:'violent crime', assault:'assault',
      robbery:'robbery', violent_protest:'violent protests', riot:'riots',
      theft:'theft', fire:'fire incidents', accident:'road accidents',
      health:'health hazards', natural_disaster:'natural disaster risk',
      infrastructure:'infrastructure disruptions', protest:'protests' };
    return map[t.type] || t.type.replace(/_/g, ' ');
  })();

  const trendNote = !trend || trend === 'stable' ? ''
    : trend === 'worsening' ? ' Incidents have been increasing recently — stay extra alert.'
    : ' Activity has been declining, which is a good sign.';

  const nightNote = nightModifier < 0 ? ' Risk tends to be higher at this time of night.' : '';

  if (score >= 80) {
    if (incidents === 0) return `This area has been quiet lately — no incidents recorded this week.${trendNote}${nightNote} Standard precautions are all you need.`;
    return `This area is generally safe. There ${incidents === 1 ? 'has been' : 'have been'} ${incidents} minor ${incidents === 1 ? 'alert' : 'alerts'} this week${threatPhrase ? `, mostly ${threatPhrase}` : ''} — nothing that should cause alarm.${trendNote}${nightNote}`;
  }
  if (score >= 60) {
    const base = threatPhrase
      ? incidents === 0 ? `This area has had some ${threatPhrase} in the past 90 days, but none this week`
                        : `This area has seen some ${threatPhrase} activity recently`
      : `There's been moderate activity in this area`;
    return `${base}${incidents > 0 ? ` — ${incidents} ${incidents === 1 ? 'incident' : 'incidents'} reported this week` : ''}. Stay aware, especially after dark.${trendNote}${nightNote}`;
  }
  if (score >= 40) {
    const base = threatPhrase ? `This area is prone to ${threatPhrase}` : `This area has elevated risk`;
    const sevNote = avgSeverity && parseFloat(avgSeverity) >= 7 ? ` Some of these incidents were serious.` : '';
    return `${base} — ${incidents} ${incidents === 1 ? 'incident has' : 'incidents have'} been recorded this week.${sevNote} Avoid isolated spots, stay on busy streets, and keep emergency contacts close.${trendNote}${nightNote}`;
  }
  const critNote = criticalZones > 0
    ? ` Including ${criticalZones} critical ${criticalZones === 1 ? 'threat' : 'threats'}${threatPhrase ? ` like ${threatPhrase}` : ''}.`
    : '';
  return `This is a high-risk area right now — ${incidents} serious ${incidents === 1 ? 'incident' : 'incidents'} reported this week.${critNote} If you must be here, travel with others, stick to well-lit public areas, and have your emergency contacts on standby.${trendNote}${nightNote}`;
}

// ─── ThreatStrip ──────────────────────────────────────────────────────────────
function ThreatStrip({ threats }) {
  if (!threats?.length) return null;
  return (
    <div className="ni-threat-strip">
      <div className="ni-threat-strip__header">
        <AlertTriangle size={12} /> Recorded in this area (90 days)
      </div>
      <div className="ni-threat-strip__chips">
        {threats.map(t => {
          const color = THREAT_COLORS[t.type] || '#6B7280';
          const bg    = THREAT_BG[t.type]    || '#F9FAFB';
          const label = THREAT_LABELS[t.type] || t.type.replace(/_/g, ' ');
          return (
            <span key={t.type} className="ni-threat-chip" style={{ background: bg, color }}>
              {label}
              <span className="ni-threat-chip__count" style={{ background: color + '22', color }}>{t.count}</span>
            </span>
          );
        })}
      </div>
    </div>
  );
}

// ─── PredictionLine ───────────────────────────────────────────────────────────
function PredictionLine({ prediction }) {
  if (!prediction?.message || prediction.confidence === 'insufficient_data') return null;
  const trendCfg = TREND_CONFIG[prediction.trend] || TREND_CONFIG.stable;
  const TIcon = trendCfg.icon;
  return (
    <div className="ni-prediction-line">
      <TIcon size={13} style={{ color: trendCfg.color, flexShrink: 0 }} />
      <span>{prediction.message}</span>
    </div>
  );
}

// ─── NoDataBanner ─────────────────────────────────────────────────────────────
function NoDataBanner({ score }) {
  return (
    <div className="ni-no-data">
      <Info size={14} style={{ flexShrink: 0, color: '#6366F1', marginTop: 2 }} />
      <span>
        This area hasn't been mapped yet in Sety's database. Score of <strong>{score}</strong> reflects data uncertainty — not confirmed danger.
      </span>
    </div>
  );
}

// ─── ExpandableRisks ──────────────────────────────────────────────────────────
function ExpandableRisks({ risks }) {
  const [expanded, setExpanded] = useState(false);
  const SHOW = 3;
  const visible = expanded ? risks : risks.slice(0, SHOW);
  const extra = risks.length - SHOW;
  return (
    <div className="ni-risks">
      {visible.map((r, i) => (
        <div key={i} className="ni-risk-row">
          <div className="ni-risk-dot" />
          <span>{typeof r === 'string' ? r : JSON.stringify(r)}</span>
        </div>
      ))}
      {extra > 0 && (
        <button className="ni-risks__toggle" onClick={() => setExpanded(v => !v)}>
          {expanded ? <><ChevronUp size={11} /> Show less</> : <><ChevronDown size={11} /> +{extra} more</>}
        </button>
      )}
    </div>
  );
}

// ─── Main ─────────────────────────────────────────────────────────────────────
export function NetworkIntelligence() {
  const dispatch     = useDispatch();
  const isMountedRef = useRef(true);
  const [activeTab,  setActiveTab] = useState('overview');
  const [mapCenter,  setMapCenter] = useState([6.5244, 3.3792]);

  const { org, loading, safetyScore, timeAnalysis, nearbyIncidents, prediction } =
    useSelector(state => ({
      org:             state.auth.organization,
      loading:         state.dashboard.listLoading,
      safetyScore:     state.dashboard.safetyScore,
      timeAnalysis:    state.dashboard.timeAnalysis,
      nearbyIncidents: state.dashboard.nearbyIncidents,
      prediction:      state.dashboard.riskPrediction,
    }), shallowEqual);

  useEffect(() => { isMountedRef.current = true; return () => { isMountedRef.current = false; }; }, []);

  useEffect(() => {
    if (org?.address?.coordinates) {
      const [lon, lat] = org.address.coordinates;
      setMapCenter([lat, lon]);
      loadData(lat, lon);
    } else {
      loadData(6.5244, 3.3792);
    }
  }, [org]);

  function loadData(lat, lon) {
    if (!lat || !lon || !isMountedRef.current) return;
    // Match mobile: safety_score, time_analysis, risk_prediction, + nearby for map tab
    dispatch(actions.fetchAllData('safety_score',     null, { lat, lng: lon }));
    dispatch(actions.fetchAllData('time_analysis',    null, { lat, lng: lon }));
    dispatch(actions.fetchAllData('risk_prediction',  null, { lat, lng: lon, days: 7 }));
    dispatch(actions.fetchAllData('nearby_incidents', null, { latitude: lat, longitude: lon, radius_km: 5, limit: 50 }));
  }

  function refreshData() {
    const coords = org?.address?.coordinates;
    if (coords) { const [lon, lat] = coords; loadData(lat, lon); }
    else loadData(6.5244, 3.3792);
  }

  // activeSafety — same shape as mobile
  const activeSafety = useMemo(() => {
    const b = safetyScore?.breakdown || {};
    return {
      score:           safetyScore?.score           ?? 0,
      level:           safetyScore?.level           ?? 'unknown',
      incidents:       b.incidents_7d               ?? b.recent_incidents_7d ?? 0,
      criticalZones:   b.critical_types_30d         ?? b.critical_types ?? 0,
      avgSeverity:     b.avg_severity_7d            ?? null,
      trend:           b.trend                      ?? 'stable',
      nightModifier:   b.night_modifier             ?? 0,
      dataConfidence:  b.data_confidence            ?? null,
      hasIncidentData: safetyScore?.has_incident_data ?? true,
      scoreReason:     safetyScore?.score_reason    ?? null,
      topThreats:      safetyScore?.top_threats     ?? [],
    };
  }, [safetyScore]);

  const isNoData      = !activeSafety.hasIncidentData || activeSafety.scoreReason === 'no_data';
  const scoreDisplay  = getScoreDisplay(activeSafety.score, activeSafety.scoreReason);
  const trendCfg      = TREND_CONFIG[activeSafety.trend] || TREND_CONFIG.stable;
  const TrendIcon     = trendCfg.icon;
  const confidenceCfg = activeSafety.dataConfidence ? CONFIDENCE_CONFIG[activeSafety.dataConfidence] : null;
  const hasData       = safetyScore || timeAnalysis || nearbyIncidents;

  const tabs = [
    { id: 'overview',      label: 'Overview',     icon: <Activity size={13} /> },
    { id: 'risk-map',      label: 'Risk Map',      icon: <MapPin size={13} /> },
    { id: 'time-analysis', label: 'Time Analysis', icon: <Clock size={13} /> },
    { id: 'predictions',   label: 'Predictions',   icon: <Brain size={13} /> },
  ];

  return (
    <div className="ni-page">

      {/* Header */}
      <div className="ni-header">
        <div className="ni-header__left">
          <h1>Safety Intelligence <span className="ni-ai-badge">AI</span></h1>
          <p>
            {org?.name} · Real-time safety insights
            {org?.address?.formatted_address && <> · <MapPin size={11} style={{ display:'inline', verticalAlign:'middle' }} /> {org.address.formatted_address}</>}
          </p>
        </div>
        <button className="ni-btn ni-btn--secondary" onClick={refreshData} disabled={loading}>
          <RefreshCw size={13} className={loading ? 'ni-spin' : ''} /> Refresh
        </button>
      </div>

      {/* Tabs */}
      <div className="ni-tabs">
        {tabs.map(t => (
          <button key={t.id} className={`ni-tab ${activeTab === t.id ? 'active' : ''}`} onClick={() => setActiveTab(t.id)}>
            {t.icon}{t.label}
          </button>
        ))}
      </div>

      {loading && !hasData && (
        <div className="ni-card"><div className="ni-loading"><Loader size={28} className="ni-spin" /><p>Loading intelligence data…</p></div></div>
      )}
      {!loading && !hasData && (
        <div className="ni-card"><div className="ni-empty"><Database size={40} /><p>No intelligence data available</p><small>Unable to load data for your location. Try refreshing.</small></div></div>
      )}

      {hasData && (
        <>
          {/* ══ OVERVIEW ══════════════════════════════════════════════════ */}
          {activeTab === 'overview' && (
            <>
              {/* Score + quick stats strip */}
              <div className="ni-strip">
                {/* Score panel */}
                <div className="ni-score-panel">
                  {/* Score card — label first, number secondary, matching mobile hierarchy */}
                  <div className="ni-score-card" style={{ background: `linear-gradient(135deg, ${scoreDisplay.color} 0%, ${scoreDisplay.color}BB 100%)` }}>
                    <div className="ni-score-card__top">
                      <div className="ni-score-card__left">
                        <div className="ni-score-card__label">{scoreDisplay.label}</div>
                        <div className="ni-score-card__num-row">
                          <span className="ni-score-card__num">{activeSafety.score}</span>
                          <span className="ni-score-card__outof">/100</span>
                        </div>
                      </div>
                      <div className="ni-score-card__icon">
                        {isNoData
                          ? <Database size={32} color="rgba(255,255,255,0.85)" />
                          : <ShieldCheck size={32} color="rgba(255,255,255,0.85)" />
                        }
                      </div>
                    </div>
                    <div className="ni-score-card__meta">
                      {isNoData
                        ? <><Database size={13} /> Not yet mapped</>
                        : <><AlertTriangle size={13} /> {activeSafety.incidents} incident{activeSafety.incidents !== 1 ? 's' : ''} this week</>
                      }
                    </div>
                  </div>

                  {/* Trend + confidence pills */}
                  <div className="ni-score-pills">
                    {!isNoData && (
                      <span className="ni-pill" style={{ color: trendCfg.color, background: trendCfg.color + '18' }}>
                        <TrendIcon size={11} /> {trendCfg.label}
                      </span>
                    )}
                    {confidenceCfg && (
                      <span className="ni-pill" style={{ color: confidenceCfg.color, background: confidenceCfg.color + '18' }}>
                        <span className="ni-pill__dot" style={{ background: confidenceCfg.color }} />
                        {confidenceCfg.label}
                      </span>
                    )}
                    {isNoData && (
                      <span className="ni-pill" style={{ color: '#6366F1', background: '#EEF2FF' }}>
                        <Info size={10} /> Uncharted area
                      </span>
                    )}
                  </div>

                  {/* Breakdown metrics */}
                  {!isNoData && (
                    <div className="ni-score-metrics">
                      {[
                        { label: 'Last 7 days',  value: activeSafety.incidents },
                        { label: 'Critical',      value: activeSafety.criticalZones },
                        { label: 'Avg severity',  value: activeSafety.avgSeverity ? `${parseFloat(activeSafety.avgSeverity).toFixed(1)}/10` : '—' },
                      ].map((m, i) => (
                        <div key={i} className="ni-score-metric">
                          <span>{m.value}</span><small>{m.label}</small>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Quick stats 2×2 */}
                <div className="ni-quick-stats">
                  {[
                    { icon: <AlertTriangle size={18}/>, bg:'#FEF2F2', color:'#DC2626', label:'Nearby Incidents', value: nearbyIncidents?.length || 0, sub:'Within 5km' },
                    { icon: <Shield size={18}/>,        bg:'#F0EEFF', color:'#5341C4', label:'Primary Threat',   value: activeSafety.topThreats?.[0] ? (THREAT_LABELS[activeSafety.topThreats[0].type] || activeSafety.topThreats[0].type) : 'None', sub: activeSafety.topThreats?.[0] ? `${activeSafety.topThreats[0].count} cases (90d)` : 'No data' },
                    { icon: <Brain size={18}/>,         bg:'#FFFBEB', color:'#D97706', label:'Predicted (7d)',   value: prediction?.predicted_incidents != null ? prediction.predicted_incidents : '—', sub: prediction?.confidence ? `${prediction.confidence} confidence` : 'Analysing…' },
                    { icon: <Clock size={18}/>,         bg:'#EFF6FF', color:'#2563EB', label:'Peak Risk Hour',  value: (timeAnalysis?.recommendations?.peak_risk_window || timeAnalysis?.recommendations?.most_dangerous_hour || '—').split(' - ')[0], sub: timeAnalysis?.recommendations?.peak_day || timeAnalysis?.recommendations?.most_dangerous_day || 'Analysing…' },
                  ].map((s, i) => (
                    <div key={i} className="ni-quick-stat">
                      <div className="ni-quick-stat__icon" style={{ background: s.bg, color: s.color }}>{s.icon}</div>
                      <div>
                        <div className="ni-quick-stat__label">{s.label}</div>
                        <div className="ni-quick-stat__value" style={{ textTransform:'capitalize' }}>{s.value}</div>
                        <div className="ni-quick-stat__sub">{s.sub}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Prediction line */}
              {!isNoData && prediction && <PredictionLine prediction={prediction} />}

              {/* Threat strip */}
              {!isNoData && activeSafety.topThreats?.length > 0 && <ThreatStrip threats={activeSafety.topThreats} />}

              {/* Analysis card */}
              <div className="ni-card">
                <div className="ni-card__header">
                  <div className="ni-card__title"><Shield size={14} /> Area Safety Analysis</div>
                  {confidenceCfg && (
                    <span className="ni-confidence-badge" style={{ color: confidenceCfg.color, background: confidenceCfg.color + '18' }}>
                      <span className="ni-pill__dot" style={{ background: confidenceCfg.color }} />
                      {confidenceCfg.label}
                    </span>
                  )}
                </div>
                <div className="ni-card__body">
                  {isNoData
                    ? <NoDataBanner score={activeSafety.score} />
                    : <p className="ni-analysis-body">{buildAnalysisBody(activeSafety)}</p>
                  }
                </div>
              </div>

              {/* Recommendations */}
              <div className="ni-card">
                <div className="ni-card__header"><div className="ni-card__title"><Target size={14} /> Recommendations</div></div>
                <div className="ni-card__body">
                  <div className="ni-recs">
                    {timeAnalysis?.recommendations?.advice && (
                      <div className="ni-rec ni-rec--warning">
                        <AlertTriangle size={16} /><div><strong>Security Timing</strong><p>{timeAnalysis.recommendations.advice}</p></div>
                      </div>
                    )}
                    {(activeSafety.score < 50) && !isNoData && (
                      <div className="ni-rec ni-rec--danger">
                        <AlertOctagon size={16} /><div><strong>Enhanced Security Needed</strong><p>Consider increasing security presence during high-risk periods.</p></div>
                      </div>
                    )}
                    {activeSafety.criticalZones > 0 && (
                      <div className="ni-rec ni-rec--danger">
                        <Shield size={16} /><div><strong>Critical Incidents Detected</strong><p>{activeSafety.criticalZones} critical incident type{activeSafety.criticalZones > 1 ? 's' : ''} recorded in the past 30 days.</p></div>
                      </div>
                    )}
                    <div className="ni-rec ni-rec--info">
                      <Activity size={16} /><div><strong>Monitor Trends</strong><p>Area activity is <strong style={{ textTransform:'capitalize' }}>{trendCfg.label.toLowerCase()}</strong> — check back regularly.</p></div>
                    </div>
                    {isNoData && (
                      <div className="ni-rec ni-rec--info">
                        <Info size={16} /><div><strong>Help Map This Area</strong><p>No incidents reported here yet. If you witness anything, reporting it helps protect your community.</p></div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Recent incidents feed */}
              <div className="ni-card">
                <div className="ni-card__header">
                  <div className="ni-card__title"><AlertTriangle size={14} /> Recent Incidents Near You</div>
                  <span className="ni-card__meta">{nearbyIncidents?.length || 0} within 5km</span>
                </div>
                <div className="ni-feed">
                  {nearbyIncidents?.length > 0 ? (
                    nearbyIncidents.slice(0, 10).map((inc, i) => (
                      <div key={i} className="ni-feed-item">
                        <div className="ni-feed-item__icon" style={{ background: getSeverityColor(inc.severity) + '18', color: getSeverityColor(inc.severity) }}>
                          <AlertTriangle size={15} />
                        </div>
                        <div className="ni-feed-item__body">
                          <div className="ni-feed-item__row">
                            <span className="ni-feed-item__type" style={{ textTransform:'capitalize' }}>{inc.type?.replace(/_/g, ' ')}</span>
                            <span className="ni-feed-item__time">{inc.time}</span>
                          </div>
                          <div className="ni-feed-item__loc"><MapPin size={11} />{inc.location}</div>
                          {inc.details && <p className="ni-feed-item__desc">{inc.details}</p>}
                        </div>
                        <div className="ni-feed-item__badge" style={{ background: getSeverityColor(inc.severity) + '18', color: getSeverityColor(inc.severity) }}>{inc.severity}</div>
                      </div>
                    ))
                  ) : (
                    <div className="ni-empty" style={{ padding:'40px 20px' }}>
                      <CheckCircle size={36} style={{ color:'#16a34a', opacity:1 }} />
                      <p>No recent incidents in your area</p>
                    </div>
                  )}
                </div>
              </div>
            </>
          )}

          {/* ══ RISK MAP ══════════════════════════════════════════════════ */}
          {activeTab === 'risk-map' && (
            <div className="ni-card">
              <div className="ni-card__header">
                <div className="ni-card__title"><MapPin size={14} /> Incident Risk Map</div>
                <span className="ni-card__meta">5km radius · {nearbyIncidents?.length || 0} incidents plotted</span>
              </div>
              <div className="ni-map-wrap">
                <MapContainer key={`${mapCenter[0]}-${mapCenter[1]}`} center={mapCenter} zoom={13} scrollWheelZoom style={{ height:'100%', width:'100%' }}>
                  <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution="&copy; OpenStreetMap contributors" />
                  <MapController center={mapCenter} />
                  <CircleMarker center={mapCenter} radius={10} pathOptions={{ color:'#5341C4', fillColor:'#5341C4', fillOpacity:0.85 }}>
                    <Popup><strong>{org?.name}</strong></Popup>
                  </CircleMarker>
                  <Circle center={mapCenter} radius={5000} pathOptions={{ color: getSeverityColor(safetyScore?.level), fillOpacity:0.07, weight:1.5 }} />
                  {nearbyIncidents?.map((inc, i) => {
                    if (!inc.coordinates || inc.coordinates.length !== 2) return null;
                    return (
                      <CircleMarker key={i} center={[inc.coordinates[1], inc.coordinates[0]]} radius={6}
                        pathOptions={{ color: getSeverityColor(inc.severity), fillColor: getSeverityColor(inc.severity), fillOpacity:0.75 }}>
                        <Popup><strong style={{ textTransform:'capitalize' }}>{inc.type?.replace(/_/g, ' ')}</strong><br /><small>{inc.location}</small></Popup>
                      </CircleMarker>
                    );
                  })}
                </MapContainer>
              </div>
            </div>
          )}

          {/* ══ TIME ANALYSIS ════════════════════════════════════════════ */}
          {activeTab === 'time-analysis' && (
            <>
              {timeAnalysis?.hourly && timeAnalysis?.daily ? (
                <>
                  <div className="ni-two-col">
                    <div className="ni-card">
                      <div className="ni-card__header"><div className="ni-card__title"><Clock size={14} /> Hourly Risk Pattern</div></div>
                      <div className="ni-card__body">
                        <div className="ni-hourly">
                          {timeAnalysis.hourly.map((h, i) => (
                            <div key={i} className="ni-hour-row">
                              <span className="ni-hour-label">{h.hour}</span>
                              <div className="ni-hour-track"><div className={`ni-hour-fill ni-hour-fill--${h.risk}`} style={{ width:`${Math.min(100, (h.incidents / 10) * 100)}%` }} /></div>
                              <span className="ni-hour-count">{h.incidents}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className="ni-card">
                      <div className="ni-card__header"><div className="ni-card__title"><Calendar size={14} /> Daily Risk Pattern</div></div>
                      <div className="ni-card__body">
                        <div className="ni-daily">
                          {timeAnalysis.daily.map((d, i) => (
                            <div key={i} className="ni-day-col">
                              <span className="ni-day-name">{d.day.substring(0, 3)}</span>
                              <div className="ni-day-track"><div className={`ni-day-fill ni-day-fill--${d.risk}`} style={{ height:`${Math.min(100, (d.incidents / 20) * 100)}%` }} /></div>
                              <span className="ni-day-count">{d.incidents}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="ni-card">
                    <div className="ni-card__header"><div className="ni-card__title"><Zap size={14} /> Timing Recommendations</div></div>
                    <div className="ni-card__body">
                      <div className="ni-recs">
                        <div className="ni-rec ni-rec--success">
                          <CheckCircle size={16} /><div><strong>Safest Time</strong><p>{timeAnalysis.recommendations?.safest_window || timeAnalysis.recommendations?.safest_hour || '—'} on {timeAnalysis.recommendations?.safest_day || '—'}</p></div>
                        </div>
                        <div className="ni-rec ni-rec--danger">
                          <AlertTriangle size={16} /><div><strong>Highest Risk</strong><p>{timeAnalysis.recommendations?.peak_risk_window || timeAnalysis.recommendations?.most_dangerous_hour || '—'} on {timeAnalysis.recommendations?.peak_day || timeAnalysis.recommendations?.most_dangerous_day || '—'}</p></div>
                        </div>
                        {timeAnalysis.recommendations?.advice && (
                          <div className="ni-rec ni-rec--info">
                            <Activity size={16} /><div><strong>Security Advice</strong><p>{timeAnalysis.recommendations.advice}</p></div>
                          </div>
                        )}
                        {timeAnalysis.data_quality?.note && (
                          <div className="ni-rec ni-rec--warning">
                            <Info size={16} /><div><strong>Data Note</strong><p>{timeAnalysis.data_quality.note}</p></div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <div className="ni-card"><div className="ni-empty"><Clock size={40} /><p>No time analysis data</p><small>Insufficient data to generate time-based risk analysis</small></div></div>
              )}
            </>
          )}

          {/* ══ PREDICTIONS ══════════════════════════════════════════════ */}
          {activeTab === 'predictions' && (
            <>
              {prediction && prediction.confidence !== 'insufficient_data' ? (
                <>
                  <div className="ni-two-col">
                    {/* Forecast */}
                    <div className="ni-card">
                      <div className="ni-card__header">
                        <div className="ni-card__title"><Brain size={14} /> 7-Day Risk Forecast</div>
                        <span className="ni-card__meta" style={{ textTransform:'capitalize' }}>{prediction.confidence} confidence</span>
                      </div>
                      <div className="ni-card__body">
                        <div className="ni-forecast">
                          <div className="ni-forecast__visual">
                            {prediction.trend === 'increasing' ? <TrendingUp size={36} /> : prediction.trend === 'decreasing' ? <TrendingDown size={36} /> : <Activity size={36} />}
                            <div className="ni-forecast__num">{prediction.predicted_incidents ?? 0}</div>
                            <div className="ni-forecast__label">Predicted Incidents</div>
                          </div>
                          <div className="ni-forecast__details">
                            {[
                              { label: 'Trend',      value: prediction.trend || 'stable' },
                              { label: 'Risk Level', value: prediction.prediction || 'low' },
                              { label: 'Likelihood', value: prediction.likelihood_pct != null ? `${prediction.likelihood_pct}%` : '—' },
                              { label: 'Based On',   value: `${prediction.based_on?.incidents_last_90d || 0} incidents (90d)` },
                            ].map((d, i) => (
                              <div key={i} className="ni-forecast__detail">
                                <span className="ni-forecast__detail-label">{d.label}</span>
                                <span className="ni-forecast__detail-value" style={{ textTransform:'capitalize' }}>{d.value}</span>
                              </div>
                            ))}
                          </div>
                        </div>
                        {prediction.message && <div className="ni-forecast__msg">{prediction.message}</div>}
                        {prediction.likelihood_pct != null && (
                          <div className="ni-confidence-bar">
                            <div className="ni-confidence-bar__track">
                              <div className="ni-confidence-bar__fill" style={{ width:`${prediction.likelihood_pct}%`, background: getSeverityColor(prediction.prediction) }} />
                            </div>
                            <span className="ni-confidence-bar__label">{prediction.likelihood_pct}% chance of incident in next 7 days</span>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Likely incident types (from prediction.likely_types — not a separate endpoint) */}
                    <div className="ni-card">
                      <div className="ni-card__header"><div className="ni-card__title"><Activity size={14} /> Likely Incident Types</div></div>
                      <div className="ni-patterns">
                        {prediction.likely_types?.length > 0 ? (
                          prediction.likely_types.map((t, i) => {
                            const color = THREAT_COLORS[t.type] || '#5341C4';
                            const label = THREAT_LABELS[t.type] || t.type.replace(/_/g, ' ');
                            return (
                              <div key={i} className="ni-pattern">
                                <div className="ni-pattern__info">
                                  <span className="ni-pattern__name" style={{ textTransform:'capitalize' }}>{label}</span>
                                  <span className="ni-pattern__count">{t.count_90d} cases (90d)</span>
                                </div>
                                <div className="ni-pattern__track">
                                  <div className="ni-pattern__fill" style={{ width:`${t.likelihood_pct}%`, background: color }} />
                                </div>
                                <span className="ni-pattern__pct">{t.likelihood_pct}%</span>
                              </div>
                            );
                          })
                        ) : (
                          <div className="ni-empty" style={{ padding:'40px 20px' }}><Database size={36} /><p>No pattern data</p></div>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Key risks */}
                  {prediction.key_risks?.length > 0 && (
                    <div className="ni-card">
                      <div className="ni-card__header"><div className="ni-card__title"><AlertOctagon size={14} /> Key Risk Factors</div></div>
                      <div className="ni-card__body"><ExpandableRisks risks={prediction.key_risks} /></div>
                    </div>
                  )}
                </>
              ) : (
                <div className="ni-card">
                  <div className="ni-empty">
                    <Brain size={40} />
                    <p>{prediction?.confidence === 'insufficient_data' ? 'Insufficient data for predictions' : 'No prediction data available'}</p>
                    <small>{prediction?.message || 'Not enough historical incidents to generate a reliable forecast.'}</small>
                  </div>
                </div>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
}